import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuidesService {

  constructor(public http: AppHttpClient) { }

  getGuides(area: string = 'admin') {
    return this.http.get('user-guides', { area });
  }

  getGuide(key: string, area: string = 'admin') {
    return this.http.get(`user-guides/${key}`, { area });
  }

  createGuide(payload: { key: string; content: string; area?: string }) {
    return this.http.post('user-guides', payload);
  }

  updateGuide(key: string, content: string, area: string = 'admin') {
    const qs = new URLSearchParams({ area }).toString();
    return this.http.put(`user-guides/${key}?${qs}`, { content });
  }

  deleteGuide(key: string) {
    return this.http.delete(`user-guides/${key}`);
  }
}
